import * as Yup from 'yup';

import { isFutureDateOnly, isValidDateOnly } from './date.helpers';

// Mirrors the server's DATE_OF_BIRTH_INVALID, which refuses the same values. A half-typed date
// in the picker formats to 'Invalid Date', which a bare required() would let through.
export const DATE_OF_BIRTH_INVALID_MESSAGE = 'Enter a real date, formatted YYYY/MM/DD';
export const DATE_OF_BIRTH_IN_FUTURE_MESSAGE = "Date of birth can't be in the future";

export const dateOfBirthSchema = (requiredMessage: string) => Yup.string()
  .required(requiredMessage)
  .test('date-of-birth', DATE_OF_BIRTH_INVALID_MESSAGE, (value) => !value || isValidDateOnly(value))
  .test('date-of-birth-not-in-future', DATE_OF_BIRTH_IN_FUTURE_MESSAGE, (value) => !isFutureDateOnly(value));
